import queries from '@apis/queries';
import Accordion from '@components/Accordion';
import Column from '@components/Column';
import Row from '@components/Row';
import Switch from '@components/Switch';
import Text from '@components/Text';
import colors from '@constants/colors';
import { useQuery } from '@tanstack/react-query';
import NativeUtil from '@utils/NativeUtil';

import useToggleLocationAgreement from './hooks/useToggleLocationAgreement';
import useToggleMarketingAgreement from './hooks/useToggleMarketingAgreement';
import styles from './styles.module.scss';

function Permissions() {
  const { data: user } = useQuery(queries.user.detail());
  const toggleMarketingAgreement = useToggleMarketingAgreement();
  const toggleLocationAgreement = useToggleLocationAgreement();

  return (
        <Accordion title='권한 설정'>
            <Column className={styles.contents}
                    spacing={16}
                    fullWidth>
                <Row fullWidth justify='space-between'>
                    <Text color={colors.gray7} size='lg'>
                        위치 정보 서비스 이용약관 동의
                    </Text>
                    <Switch checked={user?.locationAgreed}
                            setChecked={toggleLocationAgreement} />
                </Row>
                <Row fullWidth justify='space-between'>
                    <Text color={colors.gray7} size='lg'>
                        마케팅 활용 동의
                    </Text>
                    <Switch checked={user?.marketingAgreed}
                            setChecked={toggleMarketingAgreement} />
                </Row>
            </Column>
        </Accordion>
  );
}

export default Permissions;
